module.exports = "https://static.moomoo.com/components/common-redpacket/images/packet-3.280c8c8f8c.png";